<template>
  <v-container fluid class="activation-wrapper">
    <div v-if="loading">
      <v-progress-circular indeterminate size="24" class="mb-3"></v-progress-circular>
      <p>{{ $t('please_wait_while_we_activate') }}</p>
    </div>
    <div v-else>
      <p v-if="error" class="error-text">{{ error }}</p>
      <p v-else>{{ $t('activation_success_message') }}</p>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import UrlHelper from '@/util/Url'

export default {
  name: 'TvLoginCallback',
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  async created() {
    const token = this.$route.query.token
    if (!token) {
      this.error = this.$t('invalid_token')
      this.loading = false
      return
    }

    try {
      const response = await axios.post(`${UrlHelper.getApiUrl()}/auth/validate-tv-token`, { token })
      if (response.status === 200) {
        this.loading = false
      } else {
        this.error = this.$t('invalid_or_expired_token')
      }
    } catch (err) {
      this.error = this.$t('activation_error')
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped lang="scss">
.activation-wrapper {
  text-align: center;
  margin-top: 50px;
}

.error-text {
  color: red;
}
</style>
